jQuery( function ( $ ) {
	const button = $('.js-tabButton');
	const tab = $('.js-tab');

	// 切り替えボタンクリック
	button.on('click', function() {
		button.removeClass('is-active');
		$(this).addClass('is-active');
		const display = $(this).data('display');
		tab.each(function() {
			if ( $(this).data('display') === display ) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});

		// 初回のマップ切替時にAPI読み込み
		let apiReady = false;
		if( display === 'map' && ! apiReady ) {
			loadGooglemapApi();
			apiReady = true;
		}
	});

	// API読み込み
	const loadGooglemapApi = () => {
		const apiKey = 'AIzaSyAzp2JGkyQRTXmFHQVmMiiyb4uAfeXZroo';
		const scriptElm = document.createElement('script');
		scriptElm.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
		const headElm = document.querySelector('head');
		headElm.appendChild(scriptElm);
	}
} );